export default "__VITE_ASSET__a85c0ea1__"